/**
 * @generated SignedSource<<7711fdf3b12d2773714b50994d438add>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onboardingId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onboardingStatus",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "condition",
    "value": {
      "stepAction": 2
    }
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onboardingAstepId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stepStatus",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "condition",
      "value": {
        "appName": "FreshBooks"
      }
    }
  ],
  "concreteType": "AccountDelegatedAuthsTsConnection",
  "kind": "LinkedField",
  "name": "accountDelegatedAuthsTsByAccountId",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": "accountDelegatedAuthsTsByAccountId(condition:{\"appName\":\"FreshBooks\"})"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountActivationFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OnboardingAccountT",
        "kind": "LinkedField",
        "name": "onboardingAccountTByAccountId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "OnboardingAccountStepTsConnection",
            "kind": "LinkedField",
            "name": "onboardingAccountStepTsByOnboardingAid",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OnboardingAccountStepT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "onboardingAccountStepTsByOnboardingAid(condition:{\"stepAction\":2})"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByAccountId",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountActivationFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "OnboardingAccountT",
        "kind": "LinkedField",
        "name": "onboardingAccountTByAccountId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "OnboardingAccountStepTsConnection",
            "kind": "LinkedField",
            "name": "onboardingAccountStepTsByOnboardingAid",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "OnboardingAccountStepT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "onboardingAccountStepTsByOnboardingAid(condition:{\"stepAction\":2})"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByAccountId",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "772740a42a164b1c67629921aee5033c",
    "id": null,
    "metadata": {},
    "name": "AccountActivationFetchQuery",
    "operationKind": "query",
    "text": "query AccountActivationFetchQuery(\n  $accountId: UUID!\n) {\n  onboardingAccountTByAccountId(accountId: $accountId) {\n    onboardingId\n    onboardingStatus\n    onboardingAccountStepTsByOnboardingAid(condition: {stepAction: 2}) {\n      totalCount\n      nodes {\n        onboardingAstepId\n        stepStatus\n        nodeId\n      }\n    }\n    accountTByAccountId {\n      accountDelegatedAuthsTsByAccountId(condition: {appName: \"FreshBooks\"}) {\n        totalCount\n      }\n      nodeId\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "166e77aad47b633c848e5ce55f22eeb8";

module.exports = node;
